import React from "react";
import CardCountry from "../Components/Card/CardCountry";
import "./country.scss";

function Country() {
  return (
    <div className="country">
      <CardCountry />
    </div>
  );
}

export default Country;
